import React, { useContext } from 'react';
import {FormContext} from '@thinkwell/react.common';
import { useDrop } from 'react-dnd';
import CourseTree from '../models/CourseTree';
import {CourseTreeContext} from '../contexts/CourseTree';
import axios from 'axios'

export default function EditNodeDrop(props) {
  const [courseTree] = useContext(CourseTreeContext)

  const sameNode = (item) => item.id == props.beforeNodeId || item.id == props.afterNodeId || (!!item.parent_node_id && item.parent_node_id == props.intoNodeId)

  const [{ isOver, canDrop }, drop] = useDrop({
    accept: 'node',
    drop: async(item) => {
      // remove node from previous parent row
      const node = courseTree.removeNode(item.id)

      // add node to new parent row
      if (props.beforeNodeId) {
        courseTree.prependNode(props.beforeNodeId, node)
      } else if (props.afterNodeId) {
        courseTree.appendNode(props.afterNodeId, node)
      } else if (props.intoNodeId) {
        const parentNode = courseTree.findNode(props.intoNodeId)
        courseTree.addNode(parentNode, node, 0)
      }

      axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector("meta[name=csrf-token]").content
      await axios({method: 'put', url: `/nodes/${node.id}.json`, data: {node: node}})
    },
    canDrop: (item, monitor) => {
      // don't allow drop for item at previous index
      if(sameNode(item)) {
        return false
      }

      return true
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    })
  });

  const isActive = isOver && canDrop;
  let border = 'none';
  let backgroundColor = 'transparent';
  if (isActive) {
    backgroundColor = 'darkgreen';
  }
  if (canDrop) {
    border = '1px solid black'
  }

  return (
    <div ref={drop} style={{ backgroundColor, border }} className={`edit-node-drop ${props.beforeNodeId ? `before-node-id-${props.beforeNodeId}` : ''} ${props.afterNodeId ? `after-node-id-${props.afterNodeId}` : ''} ${props.intoNodeId ? `into-node-id-${props.intoNodeId}` : ''}`}>
    </div>
  );
}
